
export enum MaintenanceForwardingsDirectiveFromSteps {
  DirectiveComplexity = 'DIRECTIVE_COMPLEXITY',
  EstablishmentChoiceEntry = 'establishment_choice_entry',
  CheckinEntry = 'checkin_entry',
}

export enum MaintenanceForwardingsEstablishmentChoiceEntryStepOptions {
  ManualEntry = 'Maintenance::EstablishmentChoice::ManualEntry',
}

export enum MaintenanceForwardingsCheckinEntryStepOptions {
  AutoEntry = 'Maintenance::Transport::AutoEntry',
}

export type MaintenanceForwardingsRequiredDirectiveStepsData = {
  [MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity]?: null;
  [MaintenanceForwardingsDirectiveFromSteps.EstablishmentChoiceEntry]?: MaintenanceForwardingsEstablishmentChoiceEntryStepOptions[];
  [MaintenanceForwardingsDirectiveFromSteps.CheckinEntry]?: MaintenanceForwardingsCheckinEntryStepOptions[];
};

export type MaintenanceForwardingsShowDirectiveDetailsData = {
  name: string;
  description: string;
  can_create: boolean;
  required_directive_steps: MaintenanceForwardingsRequiredDirectiveStepsData | null;
}

export type MaintenanceForwardingsShowDirectiveDetailsResponse = {
  data: {
    data: MaintenanceForwardingsShowDirectiveDetailsData
  }
}

export type MaintenanceForwardingsDirectiveFormProps = {
  directiveDetails: MaintenanceForwardingsShowDirectiveDetailsData;
}

